import { CandidateSidebarSection } from './candidate-sidebar.types';

export const candidateSidebarSections: CandidateSidebarSection[] = [
   {
      id: 'searchWork',
      hideHeader: true,
      wrapperClassName: 'SidebarSectionTop',
      desktopBodyClassName: 'SBBody',
      items: [
         {
            id: 'search-job',
            type: 'link',
            to: '/searchjob',
            itemClassName: 'SidebarChangeLogo',
            iconClassName: 'SidebarChangeLogoBg',
            iconBackgroundSrc: '/Images/employerSide/bg10.png',
            iconSrc: '/Images/jobseekerSide/search-icon.png',
            titleKey: 'jobseekerSidebar.searchJobs',
         },
      ],
   },
   {
      id: 'myProfile',
      titleKey: 'jobseekerSidebar.userMenu',
      wrapperClassName: 'SidebarSection1',
      desktopBodyClassName: 'SBBody',
      items: [
         {
            id: 'my-cv-list',
            type: 'link',
            to: '/candidates/my-cv-list',
            itemClassName: 'SidebarCreatJob',
            iconClassName: 'SidebarCreatJobBg',
            iconBackgroundSrc: '/Images/employerSide/bg1.png',
            iconSrc: '/Images/jobseekerSide/cv-list-black.png',
            titleKey: 'jobseekerSidebar.myCVList',
         },
         {
            id: 'edit-resume',
            type: 'link',
            to: '/candidate/edit-resume',
            itemClassName: 'SidebarManageJob',
            iconClassName: 'SidebarManageJobBg',
            iconBackgroundSrc: '/Images/employerSide/bg2.png',
            iconSrc: '/Images/employerSide/icon8color.png',
            titleKey: 'jobseekerSidebar.createCV',
         },
      ],
   },
   {
      id: 'quickLinks',
      titleKey: 'jobseekerSidebar.quickLinks',
      wrapperClassName: 'SidebarSection2',
      headerClassName: 'mt-3',
      desktopBodyClassName: 'body',
      items: [
         {
            id: 'manage-alerts',
            type: 'link',
            to: '/alerts/index',
            itemClassName: 'SidebarMyProfile',
            iconClassName: 'SidebarMyProfileBg',
            iconBackgroundSrc: '/Images/employerSide/bg7.png',
            iconSrc: '/Images/jobseekerSide/Manage-Alerts.png',
            titleKey: 'jobseekerSidebar.manageAlerts',
         },
         {
            id: 'saved-jobs',
            type: 'link',
            to: '/candidate/saved-jobs',
            itemClassName: 'SidebarFavouriteJob',
            iconClassName: 'SidebarFavouriteJobBg',
            iconBackgroundSrc: '/Images/employerSide/bg4.png',
            iconSrc: '/Images/employerSide/icon4color.png',
            titleKey: 'jobseekerSidebar.savedJobs',
         },
         {
            id: 'applied-jobs',
            type: 'link',
            to: '/candidate/applied-jobs',
            itemClassName: 'SidebarChangePass',
            iconClassName: 'SidebarChangePassBg',
            iconBackgroundSrc: '/Images/employerSide/bg9.png',
            iconSrc: '/Images/jobseekerSide/Applied-Jobs-black.png',
            titleKey: 'jobseekerSidebar.appliedJobs',
         },
         {
            id: 'mailing-history',
            type: 'link',
            to: '/candidate/mailing-history',
            itemClassName: 'SidebarMailHistory',
            iconClassName: 'SidebarMailHistoryBg',
            iconBackgroundSrc: '/Images/employerSide/bg6.png',
            iconSrc: '/Images/employerSide/icon6color.png',
            titleKey: 'jobseekerSidebar.mailHistory',
         },
      ],
   },
   {
      id: 'settings',
      titleKey: 'jobseekerSidebar.myProfile',
      titleClassName: 'text-black',
      wrapperClassName: 'SidebarSection3',
      headerClassName: 'mt-3',
      desktopBodyClassName: 'body',
      items: [
         // {
         //    id: 'profile',
         //    type: 'link',
         //    to: '/candidate/profile',
         //    itemClassName: 'SidebarEditProfile',
         //    iconClassName: 'SidebarEditProfileBg',
         //    iconBackgroundSrc: '/Images/employerSide/bg8.png',
         //    iconSrc: '/Images/jobseekerSide/profile-icon.png',
         //    titleKey: 'jobseekerSidebar.profileMenu',
         // },
         {
            id: 'change-password',
            type: 'link',
            to: '/candidate/change-password',
            itemClassName: 'SidebarChangePass',
            iconClassName: 'SidebarChangePassBg',
            iconBackgroundSrc: '/Images/employerSide/bg9.png',
            iconSrc: '/Images/employerSide/icon9color.png',
            titleKey: 'jobseekerSidebar.changePassword',
         },
         {
            id: 'change-photo',
            type: 'link',
            to: '/candidates/uploadPhoto',
            itemClassName: 'SidebarChangeLogo',
            iconClassName: 'SidebarChangeLogoBg',
            iconBackgroundSrc: '/Images/employerSide/bg10.png',
            iconSrc: '/Images/employerSide/icon10color.png',
            titleKey: 'jobseekerSidebar.changePhoto',
         },
         {
            id: 'logout',
            type: 'action',
            action: 'logout',
            itemClassName: 'SidebarImportJob',
            iconClassName: 'SidebarImportJobBg',
            iconBackgroundSrc: '/Images/employerSide/bg5.png',
            iconSrc: '/Images/employerSide/icon11color.png',
            titleKey: 'jobseekerSidebar.logOut',
         },
      ],
   },
];
